import { useState, useEffect } from 'react';

const usePlatformDetection = (): string => {
  const [platform, setPlatform] = useState('');

  useEffect(() => {
    const userAgent = navigator.userAgent;

    if (userAgent.includes('iPhone')) {
      setPlatform('ios-webview');
    } else if (userAgent.includes('Android')) {
      setPlatform('android-webview');
    } else {
      setPlatform('web');
    }
  }, []);

  return platform;
};

export default usePlatformDetection;
